<template>
	<form ref="form" class="search" :action="action"  data-vv-scope="form-3" @submit.prevent="getResult('form-3')">
		<input type="search" name="q" :placeholder="placehold" class="search__input" v-validate="'required|min:3|max:250'"
			   :class="{'input': true,'invalid': errors.has('form-3.q') }">
		<button class="search__btn" type="submit">
			<img src="/static/img/ico-search.svg" alt="">
		</button>
		<span v-show="errors.has('form-3.q')" class="form__error search" >{{ errors.first('form-3.q') }}</span>
	</form>
</template>

<script>
    import {closest} from '../utils'
    import axios from 'axios';
    export default {
        name: "search",
		props:{
            placehold:'',
			action: String
		},
		methods: {
            getResult(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        this.$refs.form.submit();
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/search.vue